export default function ClockIcon(props) {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 34 35"
      fill="none"
      stroke="inherit"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16.9688 33.6746C25.7708 33.6746 32.9062 26.5391 32.9062 17.7371C32.9062 8.93502 25.7708 1.79956 16.9688 1.79956C8.16671 1.79956 1.03125 8.93502 1.03125 17.7371C1.03125 26.5391 8.16671 33.6746 16.9688 33.6746Z"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.9688 7.11206V17.7371H27.5938"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
